const GoogleDataLayerData = [
  {
    name: "Home",
    eventTitle: "homepageView",
    stageTitle: "Intermittent fasting made simple",
  },
  {
    name: "WhatName",
    eventTitle: "whatNamepageView",
    stageTitle: "Intermittent fasting made simple",
  },
  {
    name: "Goal",
    eventTitle: "goalpageView",
    stageTitle: "Intermittent fasting made simple",
  },
  {
    name: "Fasting",
    eventTitle: "fastingpageView",
    stageTitle: "Intermittent fasting made simple",
  },
  {
    name: "FastingAbout",
    eventTitle: "fastingAboutpageView",
    stageTitle: "What is Intermittent Fasting",
  },
  {
    name: "Activity",
    eventTitle: "activitypageView",
    stageTitle: "What is activity level",
  },
  {
    name: "Activity",
    eventTitle: "activitypageView",
    stageTitle: "What's your activity level",
  },
  {
    name: "Nutrition",
    eventTitle: "nutritionpageView",
    stageTitle: "Let's talk nutrition",
  },
  {
    name: "Meals",
    eventTitle: "mealspageView",
    stageTitle: "How many meals do you eat per day",
  },
  {
    name: "Dietary",
    eventTitle: "dietrypageView",
    stageTitle: "Are you currently following a specific dietary pattern",
  },
  {
    name: "Allergies",
    eventTitle: "allergypageView",
    stageTitle: "Do you have any ingredients allergy",
  },
  {
    name: "Dailywater",
    eventTitle: "dailywaterpageView",
    stageTitle: "What is your daily water intake",
  },
  {
    name: "Night",
    eventTitle: "nightpageView",
    stageTitle: "Be honest, what’s your average night like",
  },
  {
    name: "Weightloss",
    eventTitle: "weightlosspageView",
    stageTitle:
      "FastBetter uses science-based approach  to give you long-term results through sustainable weight loss.",
  },
  {
    name: "Gender",
    eventTitle: "genderpageView",
    stageTitle: "What gender were  were you assigned at birth?",
  },
  {
    name: "Testimonial",
    eventTitle: "testimonialpageView",
    stageTitle: "Staying on track can be hard, but FastBetter makes it easy",
  },
  {
    name: "Age",
    eventTitle: "agepageView",
    stageTitle: "How old are you",
  },
  {
    name: "Height",
    eventTitle: "heightpageView",
    stageTitle: "What's your height",
  },
  {
    name: "Weight",
    eventTitle: "weightpageView",
    stageTitle: "What's your weight",
  },
  {
    name: "WeightGoal",
    eventTitle: "weightGoalpageView",
    stageTitle: "What's your weight goal",
  },
  {
    name: "Motivating",
    eventTitle: "motivatingpageView",
    stageTitle:
      "Is there any specific reason  motivating you to lose weight right now?",
  },
  {
    name: "Event",
    eventTitle: "eventpageView",
    stageTitle: "Sounds exciting! when  is your Wedding?",
  },
  {
    name: "NeedLoss",
    eventTitle: "needlosspageView",
    stageTitle: "The only weight loss program you’ll ever need!",
  },
  {
    name: "Habits",
    eventTitle: "habitpageView",
    stageTitle:
      "{gender} in their {age}, wanting to lose weight have some unique needs.",
  },
  {
    name: "BodyType",
    eventTitle: "bodyTypepageView",
    stageTitle: "What is your body type",
  },
  {
    name: "EatingHabits",
    eventTitle: "eatingHabitpageView",
    stageTitle: "When do snack cravings hit you most?",
  },
  {
    name: "Emotions",
    eventTitle: "emotionspageView",
    stageTitle: "Eating  is one of the ways I usually deal with my emotions",
  },
  {
    name: "AfterWeek",
    eventTitle: "afterweekpageView",
    stageTitle:
      "After a week  or two of eating healthier or exercising, I fall back to my old routine",
  },
  {
    name: "PeopleRound",
    eventTitle: "peopleroundpageView",
    stageTitle:
      "People around me  often make it hard for me to stick to healthier habits",
  },
  {
    name: "MultiTasking",
    eventTitle: "multitaskingpageView",
    stageTitle:
      "Multitasking  while eating has become habitual for me (like eating while working or scrolling on my phone)",
  },
  {
    name: "MyPlate",
    eventTitle: "myplatepageView",
    stageTitle: "Even if I’m already full, I usually clear my plate",
  },
  {
    name: "Preliminary",
    eventTitle: "preliminarypageView",
    stageTitle: "Preliminary processing",
  },
  {
    name: "RealTalk",
    eventTitle: "realtalkpageView",
    stageTitle: "Real talk: Goal weight ",
  },
  {
    name: "Journey",
    eventTitle: "journeypageView",
    stageTitle: "During my Fast Better journey, I’d like to feel",
  },
  {
    name: "Ilike",
    eventTitle: "ilikepageView",
    stageTitle: "With FastBetter, I’d like to",
  },
  {
    name: "MySelf",
    eventTitle: "myselfpageView",
    stageTitle: "At my happy weight, I see my self",
  },
  {
    name: "Priorities",
    eventTitle: "prioritiespageView",
    stageTitle: "Which of the below best describes your current priorities",
  },
  {
    name: "Gainweight",
    eventTitle: "gainweightpageView",
    stageTitle:
      "Have you gained weight due to any life events  in recent years?",
  },
  {
    name: "Diagnosed",
    eventTitle: "diagnosedpageView",
    stageTitle: "Have you been diagnosed  with any of the following?",
  },
  {
    name: "Holistic",
    eventTitle: "holisticpageView",
    stageTitle:
      "Our holistic approach goes beyond weight loss  to improve your well-being, mood and health.",
  },
  {
    name: "Goodhand",
    eventTitle: "goodhandpageView",
    stageTitle:
      "51,146 people in their {age}  have made strides towards their goals using FastBetter.",
  },
  {
    name: "email",
    eventTitle: "emailpageView",
    stageTitle: "You’re one step away from your weight loss journey",
  },
  {
    name: "PricePlan",
    eventTitle: "priceplan_CheckoutpageView",
    stageTitle: "Price plan",
  },
  {
    name: "UserRegistrationForm",
    eventTitle: "UserRegistrationpageView",
    stageTitle: "User registration form",
  },
  {
    name: "Thankyou",
    eventTitle: "Thankyou_order_confirmation_pageView",
    stageTitle: "Thankyou for buy a plan",
  },
];

export default GoogleDataLayerData;
